// Port of api/fuel/app/classes/filter/search/games/sorts/query/game/published.php
import F from 'offline/filter/constants'
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'year',
	post: false,
	require: function(config, filter) { return sorted('year', filter) > 0 },
	run: function(config, filter, data, query) {
		if (config.ownerType === F.OWNER_USER) {
			// PHP uses COALESCE(v.game_version_year, g.game_published) for all OWNER_USER.
			// The v JOIN via c creates an INNER JOIN that filters to collection items only.
			// For collection context, this works via the standard v join chain.
			// For ratings/plays, we replicate the c JOIN side-effect.
			if (config.resultType !== F.RESULT_COLLECTION) {
				query.join('collection', 'c', 'JOIN', 'game_id', 10)
				query.where('c.user_id', '=', config.owner.get_id())
				query.join('game_version', 'v', 'LEFT JOIN', 'game_version_id', 11)
			}
			query.order('COALESCE(v.game_version_year, g.game_published)', sortReverse('year', filter), sortPriority('year', filter))
		} else {
			query.order('g.game_published', sortReverse('year', filter), sortPriority('year', filter))
		}
	}
}
